import * as types from 'packages/store/types';
import { PlatformState } from './types';

const initialState: PlatformState = {
    portalDomain: null,
    hostUrl: '',
    accessToken: null,
    bynderAccessToken: null,
    hostPort: null,
    tokenEndpoint: null,
    isAppInitializing: true,
};

export default function platformReducer(state: PlatformState = initialState, action): PlatformState {
    switch (action.type) {
        case types.UPDATE_PLATFORM_OPTIONS:
            return {
                ...state,
                ...action.options,
            };
        case types.LOGOUT:
            return {
                ...state,
                accessToken: null,
                bynderAccessToken: null,
            };
        case types.TOGGLE_APP_INITIALIZING:
            return {
                ...state,
                isAppInitializing: action.state,
            };
        default:
            return state;
    }
}
